import { DivLabel, DivValue, DivWrap } from './style';

interface TotalAreaSqFtProps {
  totalAreaSqFt: number;
}

export default function TotalAreaSqFt({ totalAreaSqFt }: TotalAreaSqFtProps) {
	return (
		<DivWrap className="roof-attr-wrap roof-total-area-wrap">
			<DivLabel className="roof-attr-label">Total Area <span>(sqft)</span>:</DivLabel>
			<DivValue className="roof-attr-value">
				{totalAreaSqFt.toFixed(2)}
			</DivValue>
		</DivWrap>
	);
}
